export enum VertexElementUsage {
  Position = 0,
  TexCoord = 1,
  Color = 2,
  Transform = 3,
}
